import { apiRequest, graphqlRequest } from './index'

export const createDeclaration = (declarationInput, declarationFields) => {
  return graphqlRequest(`
    mutation {
      createDeclaration(declarationInput: {
        ${ declarationInput }
      }){
        ${ declarationFields }
      }
    }
  `)
}

export const submitDeclaration = (declarationInput, consent, declarationFields) => {
  return graphqlRequest(`
    mutation {
      submitDeclaration(declarationInput: {
        ${ declarationInput }
      }
      consent : "${ consent }"
      ){
        ${ declarationFields }
      }
    }
  `)
}

export const getDeclarations = (recordId, declarationFields) => {
  return graphqlRequest(`
  {
    getDeclarations(recordId:"${ recordId }") {
      ${ declarationFields }
    }
  }
  `)
}

export const uploadDeclarationAttachment = (_id, recordId, category, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify({
    attachmentInfo: {
      _id,
      recordId,
      category,
    }
  }))

  return apiRequest('POST', '/api/beneficiary/rest/v1/uploadDeclarationAttachment', formData, { 'content-type': 'multipart/form-data' })
}

export const deleteDeclarationAttachment = (_id, fileKeys) => {

  return graphqlRequest(`
    mutation {
    removeDeclarationAttachment(
        _id: "${ _id }"
        fileKeys: ["${ fileKeys.join('","') }"]
      ) {
        attachments {
          category
          key
          name
          size
        }
      }
    }`)
}
